/* Liora chart links: resolve colors against current storefront variants. */
(() => {
  if (window.__lioraChartResultsLoaded) return;
  window.__lioraChartResultsLoaded = true;

  const key = (value) => String(value || '').normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
  const vendorKey = (value) => {
    const normalized = key(value);
    return normalized === 'reneeofparis' ? 'reneofparis' : normalized;
  };
  const tressAliases = {
    'Desert Ombré': 'Desert Ombre',
    'Desert Ombré Lighted': 'Desert Ombre Lighted',
    'Silver Cream Lighted': 'Silver Crème Lighted',
    'Sterling Smoke Shimmer': 'sterling-smoke-shimmer',
    'Platinum Champagne Frost': 'platinum-champagne-frost',
    'Cocoa Bean': 'Cocoa Beans',
    'Deep Forest': 'Deep Forrest',
    'Sandy Dunes': 'Sandy Dune'
  };

  function readCard(card) {
    const family = card.hasAttribute('data-lcf-card');
    const name = family ? card.querySelector('.lcf__name')?.textContent : card.dataset.lccName;
    const code = family ? card.querySelector('.lcf__code')?.textContent : card.dataset.lccCode;
    const brand = family
      ? card.closest('[data-lcf-group]')?.querySelector('.lcf__brand-title')?.textContent
      : card.dataset.lccBrand;
    let query = card.dataset.lccQuery || card.dataset.lccSearchTitle || name || '';
    if (vendorKey(brand) === 'tressallure') query = tressAliases[name] || query;
    return { name: (name || '').trim(), code: (code || '').trim(),
      brand: (brand || '').trim(), query: query.trim() };
  }

  function makeSearchUrl(color) {
    const root = window.Shopify?.routes?.root || '/';
    const url = new URL(root + 'search', window.location.origin);
    url.searchParams.set('q', 'variants.title:"' + color.name + '"');
    url.searchParams.set('type', 'product');
    url.searchParams.set('liora_color', color.name);
    if (color.brand) url.searchParams.set('liora_brand', color.brand);
    if (color.code) url.searchParams.set('liora_code', color.code);
    if (color.query && color.query !== color.name) url.searchParams.set('liora_query', color.query);
    const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url.pathname + url.search;
  }

  function enhanceLink(link) {
    const card = link.closest('[data-lcc-card], [data-lcf-card]');
    if (!card) return false;
    const color = readCard(card);
    if (!color.name) return false;
    link.setAttribute('href', makeSearchUrl(color));
    return true;
  }

  function enhanceLinks() {
    document.querySelectorAll('[data-lcc-card] [data-lcc-link], [data-lcf-card] .lcf__link')
      .forEach(enhanceLink);
  }

  // Capture preserves normal link behavior, including opening another tab,
  // while superseding older chart handlers that use a fixed product list.
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('[data-lcc-card] [data-lcc-link], [data-lcf-card] .lcf__link');
    if (link && enhanceLink(link)) event.stopPropagation();
  }, true);
  document.addEventListener('contextmenu', (event) => {
    const link = event.target.closest?.('[data-lcc-card] [data-lcc-link], [data-lcf-card] .lcf__link');
    if (link) enhanceLink(link);
  }, true);

  function readRequest(params) {
    const legacy = (params.get('q') || '').match(/^variants\.title:\s*"([\s\S]*)"$/);
    const name = params.get('liora_color') || legacy?.[1] || '';
    return { name, brand: params.get('liora_brand') || '',
      code: params.get('liora_code') || '', query: params.get('liora_query') || name };
  }

  function matchesColor(color, wanted) {
    const actual = key(color);
    if (!actual) return false;
    const names = [wanted.name, wanted.query].filter(Boolean);
    if (vendorKey(wanted.brand) === 'tressallure') {
      names.push(tressAliases[wanted.name] || wanted.name);
    }
    const candidates = new Set(names.map(key));
    if (wanted.brand && wanted.code) {
      candidates.add(key(wanted.code));
      names.forEach((name) => {
        candidates.add(key(name + wanted.code));
        candidates.add(key(wanted.code + name));
      });
    }
    return candidates.has(actual);
  }

  function matchingProducts(products, wanted) {
    const seen = new Set();
    const matches = [];
    products.forEach((product) => {
      if (!product.id || seen.has(String(product.id))) return;
      if (wanted.brand && vendorKey(product.vendor) !== vendorKey(wanted.brand)) return;
      const variants = (product.variants || []).filter((variant) => matchesColor(variant.color, wanted));
      if (!variants.length) return;
      variants.sort((a, b) => Number(b.available) - Number(a.available));
      seen.add(String(product.id));
      matches.push({ product, variant: variants[0] });
    });
    return matches.sort((a, b) => Number(b.variant.available) - Number(a.variant.available)
      || String(a.product.title).localeCompare(String(b.product.title)));
  }

  async function fetchCatalogPage(page) {
    const root = window.Shopify?.routes?.root || '/';
    const url = new URL(root + 'collections/all', window.location.origin);
    url.searchParams.set('view', 'liora-chart-feed');
    url.searchParams.set('page', String(page));
    const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(url, { signal: controller.signal, cache: 'no-store',
        headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error('Chart catalog request failed');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const feed = doc.querySelector('[data-liora-chart-feed]');
      const json = feed?.querySelector('[data-liora-chart-feed-json]');
      if (!feed || !json) throw new Error('Chart catalog missing');
      const products = JSON.parse(json.textContent);
      const pages = Number(feed.dataset.totalPages);
      if (!Array.isArray(products) || !Number.isInteger(pages) || pages < 1 || pages > 100) {
        throw new Error('Chart catalog invalid');
      }
      return { products, pages };
    } finally {
      window.clearTimeout(timeout);
    }
  }

  async function loadCatalog() {
    const first = await fetchCatalogPage(1);
    const products = first.products.slice();
    // Process every catalog page; an incomplete response is never "no matches".
    for (let page = 2; page <= first.pages; page += 3) {
      const batch = [];
      for (let next = page; next < page + 3 && next <= first.pages; next += 1) {
        batch.push(fetchCatalogPage(next));
      }
      const responses = await Promise.all(batch);
      responses.forEach((response) => products.push(...response.products));
    }
    return products;
  }

  function element(tag, className, text) {
    const node = document.createElement(tag);
    node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function productCard({ product, variant }, translate) {
    const article = element('article', 'liora-chart-result');
    const link = element('a', 'liora-chart-result__link');
    const url = new URL(product.url, window.location.origin);
    if (url.origin !== window.location.origin) throw new Error('Unexpected product URL');
    url.searchParams.set('variant', String(variant.id));
    const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    link.href = url.pathname + url.search;
    const photo = element('div', 'liora-chart-result__photo');
    if (product.image) {
      const imageUrl = new URL(product.image, window.location.origin);
      if (['http:', 'https:'].includes(imageUrl.protocol)) {
        const img = element('img', 'liora-chart-result__image');
        img.src = imageUrl.href;
        img.alt = product.title;
        img.loading = 'lazy';
        img.decoding = 'async';
        photo.appendChild(img);
      }
    }
    const body = element('div', 'liora-chart-result__body');
    body.append(element('p', 'liora-chart-result__brand', product.vendor),
      element('h2', 'liora-chart-result__title', product.title),
      element('p', 'liora-chart-result__color', variant.color));
    const price = element('p', 'liora-chart-result__price');
    if (variant.compareAt) price.append(element('s', '', variant.compareAt), document.createTextNode(' '));
    price.append(element('span', '', variant.price));
    body.appendChild(price);
    if (!variant.available) body.append(element('p', 'liora-chart-result__availability', translate('sold_out')));
    body.append(element('span', 'liora-chart-result__cta', translate('view_style')));
    link.append(photo, body);
    article.appendChild(link);
    return article;
  }

  function initResults(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const wanted = readRequest(new URL(window.location.href).searchParams);
    if (!wanted.name) return;
    const heading = root.querySelector('[data-liora-chart-heading]');
    const status = root.querySelector('[data-liora-chart-status]');
    const grid = root.querySelector('[data-liora-chart-grid]');
    const retry = root.querySelector('[data-liora-chart-retry]');
    const more = root.querySelector('[data-liora-chart-more]');
    const strings = JSON.parse(root.querySelector('[data-liora-chart-translations]').textContent);
    const translate = (name, values = {}) => Object.entries(values).reduce(
      (text, [field, value]) => text.replaceAll('[' + field + ']', String(value)), strings[name] || '');
    heading.textContent = translate('heading_color', { color: wanted.name });
    document.title = heading.textContent + ' | Liora Alternative Hair';
    let results = [];
    let displayed = 0;
    const showMore = () => {
      const fragment = document.createDocumentFragment();
      results.slice(displayed, displayed + 24).forEach((match) => fragment.appendChild(productCard(match, translate)));
      displayed = Math.min(results.length, displayed + 24);
      grid.appendChild(fragment);
      more.hidden = displayed >= results.length;
    };
    const run = async () => {
      retry.hidden = true;
      more.hidden = true;
      grid.replaceChildren();
      status.textContent = translate('loading');
      root.setAttribute('aria-busy', 'true');
      try {
        results = matchingProducts(await loadCatalog(), wanted);
        displayed = 0;
        showMore();
        status.textContent = results.length
          ? translate(results.length === 1 ? 'found_one' : 'found_many', { count: results.length })
            + (wanted.brand ? translate('by_brand', { brand: wanted.brand }) : '')
          : translate('empty');
      } catch (error) {
        grid.replaceChildren();
        status.textContent = translate('error');
        retry.hidden = false;
        more.hidden = true;
      } finally {
        root.setAttribute('aria-busy', 'false');
      }
    };
    retry.addEventListener('click', run);
    more.addEventListener('click', showMore);
    run();
  }

  function boot() {
    enhanceLinks();
    document.querySelectorAll('[data-liora-chart-results]').forEach(initResults);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
